import React from "react";
import { Button, Form, Input, message } from "antd";

import { sendForgotPasswordOTP } from "../actions";

import "../Login.scss";

const ForgotPassword1 = ({
  handleChangeStep = () => {},
  dataForm = {},
  handleChangeDataForm = () => {},
}) => {
  const onFinish = async (values) => {
    try {
      const { data } = await sendForgotPasswordOTP({
        ...values,
        configCode: "MYTOUR",
      });
      if (data.code === 200) {
        handleChangeDataForm({
          ...dataForm,
          ...values,
        });
        handleChangeStep(2);
      } else {
        data?.message && message.error(data?.message);
      }
    } catch (error) {}
  };

  const onFinishFailed = () => {};
  return (
    <>
      <Form
        colon={false}
        hideRequiredMark
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className="login-form"
      >
        <div style={{ paddingBottom: 16 }}>
          Để đặt lại mật khẩu của mình, hãy nhập email hoặc số điện thoại mà bạn
          sử dụng để đăng nhập vào hệ thống.
        </div>
        <Form.Item
          name="account"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập Nhập Email/SĐT ",
            },
          ]}
        >
          <Input placeholder="Nhập Email/SĐT" className="input-login" />
        </Form.Item>
        <Form.Item style={{ marginBottom: "16px" }}>
          <Button type="primary" htmlType="submit" className="btn-login">
            Tiếp tục
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default ForgotPassword1;
